import React from 'react';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import { useAuth } from '../context/AuthContext';
import { isPlatformOwner } from '../utils/authUser';
import Landing from './Landing';

/**
 * Public home: marketing landing for guests;
 * platform owners → /backoffice; winery users → /dashboard.
 */
const HomeRoute: React.FC = () => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F6F1EA]">
        <LoadingSpinner />
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <Navigate
        to={isPlatformOwner(user) ? '/backoffice' : '/dashboard'}
        replace
      />
    );
  }

  return <Landing />;
};

export default HomeRoute;
